import { Button, ButtonProps } from '@mui/material';
import React from 'react';
import CvGenerationModal from './CvGenerationModal';
import { ITalent, ProfessionList } from './cv-generator.types';

type DownloadTalentCvButtonProps = {
    professionList: ProfessionList;
    userData: ITalent;
    buttonProps?: ButtonProps;
    renderButton?: (openModal: () => void) => React.ReactNode;
};

const DownloadTalentCvButton = ({ professionList, userData, buttonProps, renderButton }: DownloadTalentCvButtonProps) => {
    const [isModalOpen, setIsModalOpen] = React.useState(false);
    const openModal = () => setIsModalOpen(true);

    return (
        <>
            {renderButton ? (
                renderButton(openModal)
            ) : (
                <Button
                    color="primary"
                    size="large"
                    startIcon={<i className="fi fi-br-document" />}
                    onClick={openModal}
                    {...buttonProps}>
                    Générer un CV
                </Button>
            )}
            <CvGenerationModal
                professionList={professionList}
                userData={userData}
                isOpen={isModalOpen}
                closeModal={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default DownloadTalentCvButton;
